module.exports = __webpack_public_path__ + "fonts/baronsans-extralightitalic-webfont.1f94ae9e.woff2";